import { Controller } from '@hotwired/stimulus'

// Detail view
// Clicking #toggle will append a <template> AFTER the current element. Allowing
// you to "expand" a detail view, similar to a collapse, but lets you inline a
// <tr> in a <table>
//
// Example usage:
// <tr data-controller="detail-view">
//   <td data-action="click->detail-view#toggle">
//     Click me to expand
//     <template data-detail-view-target="detailView">
//       <tr><td colspan="100%">Expanded content here</td></tr>
//     </template>
//   </td>
// </tr>
export default class extends Controller {
    static targets = ['detailView']

    #isExpanded = false
    #expandedViews = []

    connect() {
        // Check if already expanded on connect (Turbo cached back button support)
        this.#expandedViews = this.#expandedRowsAfterElement()
        if (this.#expandedViews.length > 0) {
            this.#isExpanded = true
            this.#showIcon('collapse')
        }
    }

    toggle() {
        this.#isExpanded = !this.#isExpanded
        this.#isExpanded ? this.#expand() : this.#collapse()
    }

    // Clone <template> and append each <tr> in document order after this row.
    // insertAdjacentElement('afterend', this.element) for every row would stack
    // newest-first and reverse sibling order; chain after the last inserted row.
    #expand() {
        const clonedTemplate = this.detailViewTarget.content.cloneNode(true)
        this.#expandedViews = []
        let insertAfter = this.element

        clonedTemplate.querySelectorAll('tr').forEach((row) => {
            row.dataset.detailViewExpanded = ''
            insertAfter.insertAdjacentElement('afterend', row)
            insertAfter = row
            this.#expandedViews.push(row)
        })

        this.#showIcon('collapse')
    }

    #collapse() {
        this.#expandedViews.forEach((row) => row.remove())
        this.#expandedViews = []
        this.#showIcon('expand')
    }

    #expandedRowsAfterElement() {
        const rows = []
        let next = this.element.nextElementSibling

        while (next?.hasAttribute('data-detail-view-expanded')) {
            rows.push(next)
            next = next.nextElementSibling
        }

        return rows
    }

    #showIcon(icon) {
        this.element.dataset.chevronLoadingIconsVisibleIconValue = icon
    }
}
